<template>
	<HighlightTool />
</template>

<script>
import HighlightTool from '@js/analysis/modules/Highlight/HighlightTool.vue';

export default {
	name:       'Highlight',
	components: { HighlightTool },
};
</script>

<style lang="scss" scoped>
</style>
